import request from '@/utils/request'

// 獲取
export function folderInfo(query) {
  return request({
    url: '/api/folders/folderInfo',
    method: 'get',
    params: query
  })
}

// 新增
export function createFolder(data) {
  return request({
    url: '/api/folders/folderInfo',
    method: 'post',
    data
  })
}
// 修改
export function updateFolder(data) {
  return request({
    url: '/api/folders/folderInfo',
    method: 'put',
    data
  })
}

export function deleteFolder(id) {
  return request({
    url: '/api/folders/folderInfo/' + id,
    method: 'delete'
  })
}

export function countFolder(query) {
  return request({
    url: '/api/folders/countFolder',
    method: 'get',
    params: query
  })
}
